import React from "react";
import ModalTemplate from "../modal-template";
import Typography from "components/typography";

interface IProps {
  closeModal: () => void;
  confirm: () => void;
  name: string;
}
const TakedownVideoModal = ({ closeModal, confirm, name }: IProps) => {
  return (
    <ModalTemplate
      header="Takedown Music Video?"
      close={closeModal}
      confirmText="Takedown"
      confirm={confirm}
      twoButtons
      cancelText="Cancel"
    >
      <Typography size="lg" weight="medium">
        You won’t be able to restore “{name}” after you take it down from stores
      </Typography>
    </ModalTemplate>
  );
};

export default TakedownVideoModal;
